import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Icon from '@hydra/common/components/Icon';

const useStyles = makeStyles(theme => ({
  root: { display: 'flex' },
  icon: { marginTop: theme.spacing(0.25) },
  text: { marginLeft: theme.spacing(1) }
}));

const getIconProps = success => ({
  type: success ? 'woorank-success' : 'woorank-danger',
  color: success ? 'success' : 'error'
});

export const CriteriumIconAndText = ({ text, icon, success }) => {
  const classes = useStyles();
  const iconObject = icon || getIconProps(success);

  return (
    <div className={classes.root}>
      <Icon className={classes.icon} {...iconObject} size='sm' />
      <span className={classes.text}>{text}</span>
    </div>
  );
};

CriteriumIconAndText.propTypes = {
  icon: PropTypes.object,
  success: PropTypes.bool,
  text: PropTypes.node.isRequired
};

export default CriteriumIconAndText;
